import { render, staticRenderFns } from "./OrderEdit.vue?vue&type=template&id=8fc9be70&scoped=true"
import script from "./OrderEdit.vue?vue&type=script&lang=js"
export * from "./OrderEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderEdit.vue?vue&type=style&index=0&id=8fc9be70&prod&scoped=true&lang=css"
import style1 from "./OrderEdit.vue?vue&type=style&index=1&id=8fc9be70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc9be70",
  null
  
)

export default component.exports